<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="700" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Pengiriman Penjualan</span>
					<span class="pl-2 font-weight-bold">{{detailPDO.pdo_code}}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="4">
							<div class="body-2 pt-3 oppacity-75">Tanggal Dikirim</div>
							<div class="subtitle-2">{{ detailPDO.pdo_status_created_datetime | tanggaljam }}</div>
							<div class="body-2 pt-3 oppacity-75">Status</div>
							<div class="subtitle-2">{{ detailPDO.pdo_status | toStatusPDOWH }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="body-2 pt-3 oppacity-75">Tanggal Diterima</div>
							<div v-if="detailPDO.pdo_status_delivered_datetime < 1" class="subtitle-2">-</div>
							<div v-else class="subtitle-2">{{ detailPDO.pdo_status_delivered_datetime | tanggaljam }}</div>
						</v-col>
					</v-row>
					<v-list color="grey lighten-3" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase cyan--text text--darken-2">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table dense :headers="headers" :items="detailPDO.pdo_detail" hide-default-footer>
							<template v-slot:item.pdo_detail_quantity_sent="{ item }">
								<div>{{ item.pdo_detail_quantity_sent | toNumber }}</div>
							</template>
							<template v-slot:item.pdo_detail_product_price="{ item }">
								<div>{{ item.pdo_detail_product_price | toNumber }}</div>
							</template>
							<template v-slot:item.total_price="{ item }">
								<div>{{ item.pdo_detail_product_price * item.pdo_detail_quantity_sent | toNumber }}</div>
							</template>
							<template v-slot:footer>
								<div class="d-flex justify-end pt-3">
									<div class="font-weight-bold text-right px-4">Total Pembayaran</div>
									<div class="font-weight-bold text-right px-4">{{ grandTotal | toRupiah }}</div>
								</div>
							</template>
						</v-data-table>
					</v-card>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'supplier_product_name'},
			{ text: 'Jumlah', value: 'pdo_detail_quantity_sent', align: 'center'},
			{ text: 'Harga(Rp)', value: 'pdo_detail_product_price', align: 'end'},
			{ text: 'Total Harga(Rp)', value: 'total_price', align: 'end', sortable: false},
			],
		}
	},
	computed:{
		...mapState('pdoSupplier', ['detailPDO']),

		grandTotal(){
			let total = 0
			if (this.detailPDO.pdo_detail) {
				this.detailPDO.pdo_detail.forEach( (el) => {
					total += el.pdo_detail_product_price * el.pdo_detail_quantity_sent
				});
			}
			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
	}
}
</script>
